/* eslint-disable no-sequences */
/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isLogOutModalOpen: false,
  userDetails: {
    email: '',
    emailToken: '',
    firstName: '',
    id: '',
    identityGuid: '',
    isActive: false,
    lastName: '',
    passwordResetRequestedOn: null,
    phoneNumber: null,
    roleId: '',
    roleName: '',
    updatedOn: '',
    userName: '',
    userPermissions: [],
  },
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetToInitialState(state, action) {
      (state.isLoading = false), (state.userDetails = {});
    },

    setIsLoadingState(state, { payload }) {
      state.isLoading = payload;
    },

    setUserDetailsState(state, { payload }) {
      state.userDetails = payload;
    },

    setUserPermissionsState(state, { payload }) {
      state.userDetails.userPermissions = payload;
    },

    setLogoutModalShowState(state, action) {
      state.isLogOutModalOpen = true;
    },

    setLogoutModalHideState(state, action) {
      state.isLogOutModalOpen = false;
    },
  },
});

export const {
  resetToInitialState,
  setIsLoadingState,
  setUserDetailsState,
  setLogoutModalShowState,
  setLogoutModalHideState,
  setUserPermissionsState,
} = userSlice.actions;

export const setToInitial =
  (values, cb = () => {}) =>
  (dispatch) => {
    dispatch(resetToInitialState(values));
    return cb(values);
  };

export const setIsLoading =
  (payload, cb = () => {}) =>
  (dispatch) => {
    dispatch(setIsLoadingState(payload));
  };

export const setUserDetails =
  (value, cb = () => {}) =>
  (dispatch) => {
    dispatch(setUserDetailsState(value));
  };

export const setUserPermissions =
  (value, cb = () => {}) =>
  (dispatch) => {
    dispatch(setUserPermissionsState(value));
  };

export const setLogoutModalShow =
  (value, cb = () => {}) =>
  (dispatch) => {
    dispatch(setLogoutModalShowState(value));
  };

export const setLogoutModalHide =
  (value, cb = () => {}) =>
  (dispatch) => {
    dispatch(setLogoutModalHideState(value));
  };

export default userSlice.reducer;
